import React from 'react';
import { Channel, User } from '../../types';
import { useCalendarUi } from '../../services/calendarService';
import { EventEditorModal } from './EventEditorModal';
import { EventDetailModal } from './EventDetailModal';

interface CalendarModalsHostProps {
  currentUser: User;
  channels: Channel[];
}

/**
 * 일정 편집기·상세 창의 유일한 렌더 지점 — App 루트에 한 번만 둔다.
 *
 * ⚠ 홈 카드·대화방 카드·캘린더 화면 안에서 직접 Modal을 열지 말 것. 모바일 홈은 PullToRefresh(z-10·당길 때
 *   transform) 안이라 그 안의 fixed 모달은 탭바 밑에 깔리거나 따라 움직인다(PinPickerModal 주석과 같은 함정).
 *   여는 쪽은 calendarService.requestOpenEditor/requestOpenDetail만 부른다.
 * 상세 → 수정은 상세를 닫고 편집기를 연다(두 창이 겹치지 않게). 키는 요청 seq라 같은 일정을 다시 열면 새로 그린다.
 */
export const CalendarModalsHost: React.FC<CalendarModalsHostProps> = ({ currentUser, channels }) => {
  const ui = useCalendarUi();
  return (
    <>
      {ui.detail && (
        <EventDetailModal key={`d${ui.detail.seq}`} request={ui.detail} currentUser={currentUser} channels={channels} />
      )}
      {ui.editor && (
        <EventEditorModal key={`e${ui.editor.seq}`} seed={ui.editor} currentUser={currentUser} />
      )}
    </>
  );
};
